export const results = (post) => {
	let { excerpt } = post;

	// Static Elements.
	const { link, title } = post;

	if (excerpt) {
		excerpt = `<div class="em-home-search__excerpt">${excerpt}</div>`;
	}

	/**
	 * Output links based on post data.
	 * @param  {object}  link      the post link object.
	 * @param  {string}  content   The link content.
	 * @param  {string}  className the link classes.
	 */
	const linkRender = (link, content, className = false) => {
		const rel = link.target === '_blank' ? 'rel="noopener norefferer"' : '';
		className = className ? `class="${className}"` : '';
		return `<a ${className} href="${link.url}" target="${link.target}" ${rel}>${content}</a>`;
	};

	return `
		<div class="col">
			<div class="em-home-search__item">
				<h4 class="em-home-search__title" itemprop="headline">
					${linkRender(link, title)}
				</h4>
				${excerpt}
			</div>
		</div>
	`;
};

export const noResults = (message) => `<div class="col"><p>${message}</p></div>`;
